export const STATUS_UPDATE_LOADING = 'STATUS_UPDATE_LOADING';

export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';

export const SET_SELECTED = 'SET_SELECTED';

export const SET_ROWS = 'SET_ROWS';

export const UPDATE_ROWS_STATUS = 'UPDATE_ROWS_STATUS';

export const SET_SHOW_SNACKBAR = 'SET_SHOW_SNACKBAR';

export const SET_UNIT_NO = 'SET_UNIT_NO';

export const SET_IS_LOADING = 'SET_IS_LOADING';

export const SET_IS_DATA_LOADING = 'SET_IS_DATA_LOADING'

export const SET_USERNAME = 'SET_USERNAME';

export const SET_FOUNDUNIT = 'SET_FOUNDUNIT';

export const SET_MODAL_OPEN = 'SET_MODAL_OPEN';

export const SET_ABOUT_OPEN = 'SET_ABOUT_US_OPEN';
